import { render, staticRenderFns } from "./Optin.vue?vue&type=template&id=1cdac1ca"
import script from "./Optin.vue?vue&type=script&lang=js"
export * from "./Optin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports